import $ from "jquery";
import "slick-carousel";

const sliderGalleryTrainingCta = () => {
    const el = {
        target: ".mi-trainingCta__gallery",
        nav: ".mi-trainingCta__galleryNav",
    };

    const init = () => {
        $(function () {
            if (!$(el.target).length) return;

            exec();
        });
    };

    const exec = () => {
        $(el.target).each(function () {
            const $slider = $(this);

            if ($slider.find('img').length === 1) return;

            if ($slider.hasClass("slick-initialized")) return;

            const $nav = $slider.siblings(el.nav);

            $slider.slick({
                dots: true,
                arrows: true,
                infinite: true,
                autoplay: 5000,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                adaptiveHeight: true,
                appendArrows: $nav,
                appendDots: $nav,
                prevArrow: '<button class="slick-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none"><path d="M40 53.12 22.611 35.734a5.296 5.296 0 0 1 0-7.466L40 10.88" stroke="currentColor" stroke-width="4.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
                nextArrow: '<button class="slick-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none"><path d="m23.76 53.12 17.386-17.386a5.296 5.296 0 0 0 0-7.466L23.76 10.88" stroke="currentColor" stroke-width="4.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            });

            $slider.data("slick-instance", $slider.slick("getSlick"));
        });
    };

    init();
};

try {
    sliderGalleryTrainingCta();
} catch (error) {
    console.error(error);
}
